import { render } from "./SurveyModal.vue?vue&type=template&id=f65ee332&scoped=true"
import script from "./SurveyModal.vue?vue&type=script&lang=js"
export * from "./SurveyModal.vue?vue&type=script&lang=js"

import "./SurveyModal.vue?vue&type=style&index=0&id=f65ee332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f65ee332"]])

export default __exports__